// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"372":"6eb1f52e","734":"59ed41bd","934":"f27477e9"}[chunkId] + ".js";
};